<template>
  <div id="app">
    <the-header />
    <router-view :key="$route.meta.viewKey || $route.fullPath" />
    <the-player />

    <the-login-modal />
    <the-signup-modal />
    <the-plan-selection-modal />
    <the-password-reset-modal />
    <the-license-selection-modal />
    <the-collections-modal />
    <the-preview-download-modal />
    <the-subscription-download-modal />
    <the-track-prompt-modal />
    <input
      id="clipboardInput"
      type="text"
      style="position: absolute; left: -9999px;"
      aria-hidden="true"
      tabindex="-1"
    >
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import ThePlayer from '@/components/ThePlayer.vue'
import TheLoginModal from '@/components/TheLoginModal.vue'
import TheSignupModal from '@/components/TheSignupModal.vue'
import ThePlanSelectionModal from '@/components/ThePlanSelectionModal.vue'
import TheCollectionsModal from '@/components/TheCollectionsModal.vue'
import TheLicenseSelectionModal from '@/components/TheLicenseSelectionModal.vue'
import ThePasswordResetModal from '@/components/ThePasswordResetModal.vue'
import ThePreviewDownloadModal from '@/components/ThePreviewDownloadModal.vue'
import TheSubscriptionDownloadModal from '@/components/TheSubscriptionDownloadModal.vue'
import TheTrackPromptModal from '@/components/TheTrackPromptModal.vue'
import utm from '@segment/utm-params'
import { isTokenExpired } from './utils/auth'

export default {
  components: {
    TheHeader,
    ThePlayer,
    TheLoginModal,
    TheSignupModal,
    ThePlanSelectionModal,
    TheCollectionsModal,
    TheLicenseSelectionModal,
    ThePasswordResetModal,
    ThePreviewDownloadModal,
    TheSubscriptionDownloadModal,
    TheTrackPromptModal
  },

  beforeCreate () {
    this.$store.dispatch('waffle/ensureLoaded')

    const refreshToken = this.$store.getters['auth/refreshToken']

    if (refreshToken && !isTokenExpired(refreshToken)) {
      this.$store.dispatch('auth/refreshToken')
        .then(() => {
          this.$store.dispatch('common/initAuthenticated')
        })
    } else {
      if (this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('common/initAuthenticated')
      }
    }

    this.$store.dispatch('common/initPublic')

    // Set campaign data if present.
    const campaign = utm(window.location.search)
    const empty = Object.keys(campaign).length === 0 && campaign.constructor === Object
    if (!empty) {
      this.$cookies.set('__campaign', campaign, 60 * 60 * 24 * (365 / 2)) // Expires in half a year.
    }

    // Set create with trial boolean.
    const hasTrialModeCookie = this.$cookies.isKey('__cswt')
    const trialModeOverride = Boolean(parseInt(process.env.VUE_APP_DEFAULT_TO_TRIAL))
    if (hasTrialModeCookie || trialModeOverride) {
      this.$store.dispatch('subscriptions/setCreateSubscriptionWithTrial', true)
    }
  },

  metaInfo: {
    titleTemplate: '%s | Sonata'
  }
}
</script>

<style>

</style>
